import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { Md5 } from 'md5-typescript';
import { ConfirmedValidator } from '../confirmed.validator';
import { UtilitaService } from '../services/utilita.service';

@Component({
  selector: 'app-impostapasswordperaccesso',
  templateUrl: './impostapasswordperaccesso.component.html',
  styleUrls: ['./impostapasswordperaccesso.component.css']
})
export class ImpostapasswordperaccessoComponent implements OnInit {
  frmInserimento!: FormGroup;



  constructor(private fb: FormBuilder, public router: Router, private srvUtilita: UtilitaService,
    private snackBar: MatSnackBar) { }

  ngOnInit(): void {
    this.frmInserimento = this.fb.group({
    Email: [null, [Validators.pattern('[a-zA-Z0-9.-_]{1,}@[a-zA-Z0-9.-]{2,}[.]{1}[a-zA-Z]{2,}')]],
      Password: [
        '',
        [
          Validators.required,
          Validators.minLength(8),
          Validators.pattern('^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!.@$%^&*-]).{8,}$')
        ]
      ],
      ConfermaPassword: ['', [Validators.required]],
      CodiceFiscale: [null, [Validators.pattern('^([A-Z]{6}[0-9LMNPQRSTUV]{2}[ABCDEHLMPRST]{1}[0-9LMNPQRSTUV]{2}[A-Z]{1}[0-9LMNPQRSTUV]{3}[A-Z]{1})$|([0-9]{11})$')]],
    }, {
      validators: [
        ConfirmedValidator('Password', 'ConfermaPassword')
      ]
    })

  }

  btnSalva() {
    let objInserimento: any
    objInserimento = this.frmInserimento.value

    let sPassword: string = "";
    sPassword = Md5.init(objInserimento.Password);

    let codiceutente = JSON.parse(localStorage.getItem('username') || '0').Email;

    const obj = {
      sEmail: codiceutente,
      sPassword: sPassword,
      sCodiceFiscale: objInserimento.CodiceFiscale
    }

    this.srvUtilita.postObj('Login/PostPrimoAccesso', obj).subscribe((res: any) => {
      this.showMessage("Password impostata in modo corretto. E' ora possibile collegarsi all'area riservata. ", "OK");

      this.router.navigate(['/login/']);
    }, (err: any) => {
        this.showMessage(err.error.Message, 'OK')
   // console.log(err.error.Message, 'ERRORE');
    })

  }

  showMessage(message: string, action: string) {
    this.snackBar.open(message, action, { duration: 3000 })
  }

}
